import React, { createContext, useState } from "react";

export const DialogContext = createContext();

export const DialogContextProvider = ({ children }) => {
  const [dialog, setDialog] = useState({
    addOrgDialog: { open: false, userId: null },
    addPlanDialog: false,
    addObjectiveDialog: { open: false },
    addMetricDialog: { open: false },
    addRockDialog: { open: false, quarter: 1, value: null, objective: null, duplicate: null },
    addSuccessCriteriaDialog: { open: false },
    addTodoDialog: { open: false, referenceId: null, referenceModel: null, category: null, value: null, user: null },
    addWeeklyTargetDialog: { open: false },
    addMeetingDialog: { open: false },
  });
  return <DialogContext.Provider value={{ dialog, setDialog }}>{children}</DialogContext.Provider>;
};
